import { setRequestAdapter, setRestRequestAdapter } from './config-adapters';
import { DEVICE_ID_URL } from './constants';
const DEFAULT_BUFFER_SIZE = 10;
const DEFAULT_SESSION_LIFETIME = 600000;
const isNaturalNumber = number => {
  return Number.isFinite(number) && Number.isInteger(number) && number > 0;
};
let configBufferSize = DEFAULT_BUFFER_SIZE;
let configReportUrl = '';
const configDeviceIdUrl = DEVICE_ID_URL;
let configHashAlgorithm;
let configHashSalt = '';
let configSessionLifetime = DEFAULT_SESSION_LIFETIME;

/**
 * Установка размера пакета событий в сетевом запросе
 * @param {Number} bufferSize количество элементов в массиве body.data
 * @return {void}
 */
export const setBufferSize = bufferSize => {
  if (isNaturalNumber(bufferSize)) {
    configBufferSize = bufferSize;
  }
};
export const getBufferSize = () => {
  return configBufferSize;
};

/**
 * Установка адреса для отправки метрик
 * @param {String} reportUrl адрес для отправки метрик
 * @return {void}
 */
export const setReportUrl = reportUrl => {
  configReportUrl = reportUrl;
};
export const getReportUrl = () => {
  return configReportUrl;
};

/**
 * @deprecated Адрес для deviceId устанавливается самостоятельно
 * Установка адреса для получения deviceId. Метод пытается сразу же получить deviceId
 * @param {String} deviceIdUrl адрес для получения deviceId
 * @return {void}
 */
export const setDeviceIdUrl = deviceIdUrl => {};
export const getDeviceIdUrl = () => {
  return configDeviceIdUrl;
};

/**
 * Переопределение алгоритма хэширования
 * @param {CreateHash} hashAlgorithm алгоритм хэширования
 * @return {void}
 */
export const setHashAlgorithm = hashAlgorithm => {
  configHashAlgorithm = hashAlgorithm;
};
export const getHashAlgorithm = () => {
  return configHashAlgorithm;
};

/**
 * Переопределение соли для алгоритма хэширования
 * @param {String} hashSalt соль для алгоритма хэширования
 * @return {void}
 */
export const setHashSalt = hashSalt => {
  configHashSalt = hashSalt;
};
export const getHashSalt = () => {
  return configHashSalt;
};

/**
 * Переопределение времени жизни сессии clickstream
 * @param {Number} sessionLifetime время жизни сессии clickstream, миллисекунд
 * @return {void}
 */
export const setSessionLifetime = sessionLifetime => {
  configSessionLifetime = sessionLifetime;
};
export const getSessionLifetime = () => {
  return configSessionLifetime;
};

/**
 * Объект первичных настроек Clickstream
 */

export { setRequestAdapter, setRestRequestAdapter };

/**
 * Основной метод, определяющий логику работы SDK
 * @param {Config} config параметры настройки Clickstream
 * @return {void}
 */
export const setConfig = ({
  reportUrl,
  deviceIdUrl,
  bufferSize,
  requestAdapter,
  restRequestAdapter,
  hashAlgorithm,
  hashSalt,
  sessionLifetime
}) => {
  if (reportUrl) {
    setReportUrl(reportUrl);
  }
  if (deviceIdUrl) {
    setDeviceIdUrl(deviceIdUrl);
  }
  if (bufferSize) {
    setBufferSize(bufferSize);
  }
  if (requestAdapter) {
    setRequestAdapter(requestAdapter);
  }
  if (restRequestAdapter) {
    setRestRequestAdapter(restRequestAdapter);
  }
  if (hashAlgorithm) {
    setHashAlgorithm(hashAlgorithm);
  }
  if (hashSalt) {
    setHashSalt(hashSalt);
  }
  if (sessionLifetime) {
    setSessionLifetime(sessionLifetime);
  }
};